import { useState } from 'react';
import { Table, Button, Badge } from 'react-bootstrap';
import { useParams, useNavigate, Link } from 'react-router-dom';
import { FaEdit, FaPlus, FaExternalLinkAlt } from 'react-icons/fa';

import Paginate from '../components/Paginate';
import Loader from '../components/Loader';
import Message from '../components/Message';

import { useGetMyBlogPostsQuery } from '../slices/blogsApiSlice';

export default function MyBlogsScreen() {
  const { pageNumber } = useParams();
  const page = Number(pageNumber) || 1;
  const navigate = useNavigate();

  const [itemsPerPage] = useState(
    Number(localStorage.getItem('myBlogsPerPage')) || 10
  );

  const { data, isLoading, error } = useGetMyBlogPostsQuery({ page, pageSize: itemsPerPage });

  const basePath = `/me/blogs`;

  if (isLoading) return <Loader />;
  if (error) {
    return <Message variant='danger'>{error?.data?.message || error.error}</Message>;
  }

  return (
    <>
      <div className='d-flex justify-content-between align-items-center' style={{ marginTop: '32px', marginBottom: '16px' }}>
        <h1>My Blog Posts</h1>
        <Link to={`/me/blogs/new`}>
          <Button variant='primary'><FaPlus className='me-1' />New Post</Button>
        </Link>
      </div>

      {data.posts.length === 0 ? (
        <Message>You haven't written any blog posts yet.</Message>
      ) : (
        <Table striped hover responsive className='table-sm'>
          <thead>
            <tr>
              <th>Title</th>
              <th>Status</th>
              <th>Visibility</th>
              <th>Date</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {data.posts.map((post) => (
              <tr key={post._id}>
                <td>{post.title}</td>
                <td>
                  <Badge bg={post.status === 'published' ? 'success' : 'secondary'}>
                    {post.status}
                  </Badge>
                  {post.isRestricted && (
                    <Badge bg='danger' className='ms-1'>
                      Restricted
                    </Badge>
                  )}
                </td>
                <td>
                  <Badge bg={post.isPrivate ? 'secondary' : 'success'}>
                    {post.isPrivate ? 'Private' : 'Public'}
                  </Badge>
                </td>
                <td>{new Date(post.createdAt).toLocaleDateString()}</td>
                <td>
                  <div className='d-flex gap-1'>
                    {post.status === 'published' && !post.isPrivate && (
                      <Button
                        size='sm'
                        variant='outline-secondary'
                        title='View'
                        onClick={() => navigate(`/blog/post/${post.slug}`)}
                      >
                        <FaExternalLinkAlt />
                      </Button>
                    )}
                    <Button
                      size='sm'
                      variant='outline-primary'
                      title='Edit'
                      onClick={() => navigate(`/me/blogs/edit/${post._id}`)}
                    >
                      <FaEdit />
                    </Button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      )}

      <div className='d-flex justify-content-center' style={{ margin: '32px 0' }}>
        <Paginate
          totalPages={data?.totalPages}
          currentPage={data?.currentPage}
          basePath={basePath}
          firstPageIsBasePath={true}
        />
      </div>
    </>
  );
}
